export default __webpack_public_path__ + "locales/en/BackupCodesDialog.json?hash=0043a910f55ecd5892bd865ec980b132";